module.exports = __webpack_public_path__ + "static/img/common_banner.61d5f28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/common_banner.jpg
// module id = y4XD
// module chunks = 5